import { render, staticRenderFns } from "./EditLabelModal.vue?vue&type=template&id=5df30e0a&"
import script from "./EditLabelModal.vue?vue&type=script&lang=js&"
export * from "./EditLabelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df30e0a')) {
      api.createRecord('5df30e0a', component.options)
    } else {
      api.reload('5df30e0a', component.options)
    }
    module.hot.accept("./EditLabelModal.vue?vue&type=template&id=5df30e0a&", function () {
      api.rerender('5df30e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBookings/components/EditLabelModal.vue"
export default component.exports